<template>
    <div class="pixi-renderer">
        <canvas ref="renderCanvas" class="max-w-full max-h-full mx-auto shadow-lg overflow-hidden rounded-lg" style="width:480px;"></canvas>
        <!-- All child <template> elements get added in here -->
        <slot></slot>
    </div>
</template>

<script>
    import Vue from 'vue';
    import * as PIXI from 'pixi.js';
    import {saveAs} from 'file-saver';

    export default {
        props: {
            width: Number,
            height: Number,
        },

        data() {
            return {
                // These need to be contained in an object because providers are not reactive.
                PIXIWrapper: {
                    // Expose PIXI and the created app to all descendants.
                    PIXI,
                    PIXIApp: null,
                },
                // Expose the event bus to all descendants so they can listen for the app-ready event.
                EventBus: new Vue(),
            }
        },
        // Allows descendants to inject everything.
        provide() {
            return {
                PIXIWrapper: this.PIXIWrapper,
                EventBus: this.EventBus,
            }
        },

        mounted() {
            // Determine the width and height of the renderer wrapper element.
            const renderCanvas = this.$refs.renderCanvas;
            const w = renderCanvas.offsetWidth;
            const h = renderCanvas.offsetWidth * this.height / this.width;

            // Create a new PIXI app.
            this.PIXIWrapper.PIXIApp = new PIXI.Application({
                view: renderCanvas,
                width: w,
                height: h,
                backgroundColor: 0x1099bb,
            });

            this.$el.appendChild(this.PIXIWrapper.PIXIApp.view);

            this.EventBus.$emit('ready');
        },

        methods: {
            download() {
                const base64 = this.PIXIWrapper.PIXIApp.renderer.extract.base64(this.PIXIWrapper.PIXIApp.stage);
                this.resizeImage(base64, (base64) => {
                    const blob = this.base64toBlob(base64);

                    if (this.isiOS()) {
                        const a = document.createElement('a');
                        a.href = URL.createObjectURL(blob);
                        const evt = document.createEvent('MouseEvent');
                        evt.initEvent("click", true, false);
                        a.dispatchEvent(evt);
                    } else {
                        saveAs(blob, "download.jpg");
                    }
                });
            },

            resizeImage(base64, callback) {
                let MIN_SIZE = 980;
                let canvas = document.createElement('canvas');
                let ctx = canvas.getContext('2d');
                let image = new Image();
                image.crossOrigin = "Anonymous";

                image.onload = function (event) {
                    let dstWidth, dstHeight;

                    if (this.width > this.height) {
                        dstWidth = MIN_SIZE;
                        dstHeight = this.height * MIN_SIZE / this.width;
                    } else {
                        dstHeight = MIN_SIZE;
                        dstWidth = this.width * MIN_SIZE / this.height;
                    }

                    canvas.width = dstWidth;
                    canvas.height = dstHeight;
                    ctx.drawImage(this, 0, 0, this.width, this.height, 0, 0, dstWidth, dstHeight);
                    callback(canvas.toDataURL());
                };

                image.src = base64;
            },

            base64toBlob(base64) {
                const bin = atob(base64.replace(/^.*,/, ''));
                let buffer = new Uint8Array(bin.length);

                for (let i = 0; i < bin.length; i++) {
                    buffer[i] = bin.charCodeAt(i);
                }

                // Blobを作戝
                try {
                    var blob = new Blob([buffer.buffer], {
                        type: 'image/jpeg'
                    });
                } catch (e) {
                    return false;
                }

                return blob;
            },

            print() {
                document.querySelectorAll('body > *').forEach(function (elm){
                    elm.classList.add('print:hidden');
                });

                const base64 = this.PIXIWrapper.PIXIApp.renderer.extract.base64(this.PIXIWrapper.PIXIApp.stage);
                let img = new Image();
                img.src = base64;

                img.onload = () => {
                    window.print();

                    img.remove();

                    document.querySelectorAll('body > *').forEach(function (elm){
                        elm.classList.remove("print:hidden");
                    });
                };

                document.body.appendChild(img);
            },

            isiOS() {
                return /iP(hone|(o|a)d)/.test(navigator.userAgent);
            },
        }
    }
</script>
